/* eslint-disable */

export enum OnboardingStatus {
  UNUSED = 0,
  NEW = 1,
  REMIND_ME_LATER = 2,
  SETUP_DONE = 3,
  UNRECOGNIZED = -1,
}

export enum Appearance {
  DEVICE = 0,
  LIGHT = 1,
  DARK = 2,
  UNRECOGNIZED = -1,
}

export interface UserSetting {
  upn: string;
  trackerId: string;
  onboardingDismissCounter: OnboardingStatus;
  hasChangedWidgets: boolean;
  weekStartsOn: number;
  showEmptyDaysInCalendar: boolean;
  showGlobalNews: boolean;
  showCountryNews: boolean;
  showLocalNews: boolean;
  showInterNews: boolean;
  showOutlook: boolean;
  showWorkschedule: boolean;
  showHfbSalesData: boolean;
  showStoreSalesData: boolean;
  showCountrySalesData: boolean;
  showGlobalSalesData: boolean;
  machineTranslationEnabled: boolean;
  showTeams: boolean;
  showYammer: boolean;
  appearance: Appearance;
}

export interface UserSettingResponse {
  item: UserSetting | undefined;
}

export interface UserSettingList {
  upns: string[];
  count: number;
}

export interface FindUserSettingRequest {
  upn: string;
}

export interface FindActiveUsersRequest {
  top: number;
  skip: number;
}

export interface Impersonation {
  upn: string;
  country?: string | undefined;
  site?: string | undefined;
  isStoreCoWorker?: boolean | undefined;
  isIngkaCentresCoWorker?: boolean | undefined;
  isRetailCoWorker?: boolean | undefined;
  isConsultant?: boolean | undefined;
  isInternal?: boolean | undefined;
}

export interface ImpersonationResponse {
  item: Impersonation | undefined;
}

export interface GraphExtensionAttributes {
  extensionAttribute9: string;
  extensionAttribute13: string;
}

export interface GraphUser {
  id: string;
  userPrincipalName: string;
  onPremisesSamAccountName: string;
  employeeId: string;
  officeLocation: string;
  onPremisesImmutableId: string;
  country: string;
  onPremisesExtensionAttributes: GraphExtensionAttributes | undefined;
  companyName: string;
}

export interface GraphUserResponse {
  item: GraphUser | undefined;
}

export interface FindGraphUserRequest {
  upn?: string | undefined;
  onPremisesImmutableId?: string | undefined;
}

export interface IsMemberOfGraphGroupRequest {
  upn: string;
  groupIds: string[];
}

export interface GroupMembership {
  id: string;
  isMember: boolean;
}

export interface IsMemberOfGroupResponse {
  items: GroupMembership[];
  count: number;
}

export interface PAOMUser {
  hireDate: string;
  dateOfBirth: string;
  partTimeIndicator: boolean;
  businessUnitType: string;
  division: string;
}

export interface PAOMResponse {
  item: PAOMUser | undefined;
}
